<template>
  <div>
    <div class="kit__utils__heading">
        <h5><span class="mr-3">{{this.$route.meta.title}}</span></h5>
    </div>
    <div class="card">
        <div class="card-header card-header-flex">
            <div class="d-flex flex-column justify-content-center mr-auto">
                <h5 class="mb-0">{{(this.$route.params.bankSetId !== 'all' && this.$route.params.bankSetId > 0) ? 'บัญชีธนาคาร :' : ''}} {{ (this.$route.params.bankSetId !== 'all' && this.$route.params.bankSetId > 0) ? this.accountName : '' }}</h5>
            </div>
            <div class="d-flex flex-column justify-content-center">
                <a class="btn btn-primary" href="javascript: void(0);" @click="showModal('insert')">เพิ่มบัญชีธนาคาร</a>
            </div>
        </div>
        <div class="card-body">
          <div class="card-header card-header-flex">
            <div class="d-flex flex-column justify-content-center mr-auto">
              <h5 class="mb-0"></h5>
            </div>
            <div class="d-flex flex-column justify-content-center">
              <a class="btn btn-primary" href="javascript: void(0);" @click="refreshData()"><i
                  class="fe fe-rotate-cw mr-1" /> รีเฟรช</a>
            </div>
          </div>
          <a-table :columns="columns" :dataSource="data" rowKey='bankServiceId' :scroll="{ x: 1500 }"
          :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true }">
            <!-- <h6 slot="bankServiceType" slot-scope="text">
              <b-badge pill :variant="(text === 1)?'success':'danger'">{{(text === 1)?'บัญชีรับ':(text === 2)?'บัญชีถอน':"ไม่พบข้อมํูล"}}</b-badge>
            </h6> -->
            <span slot="bankServiceType" slot-scope="text">
              <a-tag :color="(text === 1)?'green':'red'">
                  {{(text === 1)?'บัญชีรับ':(text === 2)?'บัญชีถอน':(text === 3)?'บัญชีถอนคืนลูกค้า':(text === 4)?'บัญชีถอนคอมมิชชั่น':(text === 5)?'บัญชีถอนตู้':"ไม่พบข้อมํูล"}}
              </a-tag>
            </span>
            <h6 slot="status" slot-scope="status,record">
              <b-badge pill href="#" @click="useAction(record.bankServiceId,status)"  :variant="getStatus('bankService',status).color">{{getStatus('bankService',status).name}}</b-badge>
            </h6>
            <span slot="Action" slot-scope="text,record">
              <a-dropdown>
                <a-menu slot="overlay">
                  <a-menu-item @click="showModal('update',record.bankServiceId)">แก้ไขบัญชี </a-menu-item>
                  <a-menu-item @click="detailStatement(record.bankServiceId)">ดูสเตทเม้น</a-menu-item>
                  <a-menu-item @click="pullStatement(record.bankServiceId)">ดึงสเตทเม้น </a-menu-item>
                </a-menu>
            <a-button style="margin-left: 8px"> จัดการ <a-icon type="down" /> </a-button>
          </a-dropdown>
            </span>
          </a-table>
        </div>
    </div>
    <a-modal :title="this.form.title" v-model="visible" ok-text="ยืนยัน" cancel-text="ยกเลิก" @ok="handleOk" @cancel="handleCancel">
      <a-form-model :model="form" layout="vertical">
        <div class="row">
          <div class="col-md-6">
            <!-- ชุดบัญชี -->
            <a-form-model-item label="ชุดบัญชี">
              <a-select :disabled="(form.bankSetId !== '' && form.type === 'update' || this.$route.params.bankSetId !== 'all')" v-model="form.bankSetId" placeholder="กรุณาเลือกข้อมูล">
                <a-select-option v-for="(item , index) in bankSet" :key="index" :value="item.bankSetId">
                    {{ item.bankSetName }} ( {{ (item.bankType === 1)?'บัญชีรับ':(item.bankType === 2)?'บัญชีถอน':(item.bankType === 3)?'บัญชีถอนคืนลูกค้า':(item.bankType === 4)?'บัญชีถอนคอมมิชชั่น':(item.bankType === 5)?'บัญชีถอนตู้':"ไม่พบข้อมํูล"}} )
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </div>
          <div class="col-md-6">
            <a-form-model-item label="เลขบัญชี">
              <a-input v-model="form.accountNumber" />
            </a-form-model-item>
          </div>
          <div class="col-md-12">
            <a-form-model-item label="ธนาคาร">
              <a-select v-model="form.bankId" placeholder="กรุณาเลือกข้อมูล">
                <a-select-option v-for="(item , index) in bank" :key="index" :value="item.bankId">
                    {{ item.bankName }}
                </a-select-option>
              </a-select>
             </a-form-model-item>
          </div>
          <div class="col-md-6">
            <a-form-model-item label="ยูสเซอร์เนม">
              <a-input v-model="form.accountUsername" />
            </a-form-model-item>
          </div>
          <div class="col-md-6">
            <a-form-model-item label="พาสเวิร์ด">
              <a-input-password v-model="form.accountPassword" />
            </a-form-model-item>
          </div>
          <!-- <div class="col-md-12" v-show="(form.bankId === 5)">
            <a-form-model-item label="PIN">
              <a-input-password v-model="form.bankPIN" />
            </a-form-model-item>
          </div> -->
          <!-- <div class="col-md-6">
            <a-form-model-item label="โยกเงิน/ถอนเงิน สูงสุด">
              <a-input-number style="width: 100%" v-model="form.tranferMax" />
            </a-form-model-item>
          </div>
          <div class="col-md-6">
            <a-form-model-item label="เงินในบัญชีสูงสุด">
              <a-input-number style="width: 100%" v-model="form.amountMax" />
            </a-form-model-item>
          </div> -->
        </div>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex'
import { getName } from '@/utils/status'
import apiClient from '@/services/api'
// import moment from 'moment'
import Swal from 'sweetalert2'
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
export default {
  data() {
    return {
      data: [],
      bankSet: [],
      bank: [
        {
          bankId: 4,
          bankName: 'ธ.กรุงไทย (ktb)',
        },
        {
          bankId: 5,
          bankName: 'ธ.ไทยพาณิชย์ (scb)',
        },
        {
          bankId: 6,
          bankName: 'ธ.กสิกรไทย (kbank)',
        },
        {
          bankId: 1,
          bankName: 'ธ.กรุงศรีอยุธยา (bay)',
        },
        {
          bankId: 2,
          bankName: 'ธ.กรุงเทพ (bbl)',
        },
      ],
      columns: [
        {
          title: 'ลำดับ',
          key: 'bankServiceId',
          dataIndex: 'bankServiceId',
        },
        {
          title: 'คู่ค้า',
          key: 'operatorName',
          dataIndex: 'operatorName',
          sorter: (a, b) => a.operatorName.length - b.operatorName.length,
          filters: [],
          onFilter: (value, record) =>
            record.operatorName.toLowerCase().includes(value.toLowerCase()),
        },
        {
          title: 'บัญชี',
          key: 'bankServiceSystem',
          dataIndex: 'bankServiceSystem',
          filters: [
            { text: 'scb', value: 5 },
            { text: 'kbank', value: 6 },
            { text: 'ktb', value: 4 },
            { text: 'bay', value: 1 },
          ],
          onFilter: (value, record) => record.bankId.toString().includes(value.toString()),
        },
        {
          title: 'ประเภท',
          key: 'bankServiceType',
          dataIndex: 'bankServiceType',
          scopedSlots: { customRender: 'bankServiceType' },
          // customRender: (text, row, index) => {
          //   return
          // },
        },
        {
          title: 'เงินในบัญชี',
          key: 'balance',
          dataIndex: 'balance',
          customRender: (text, row, index) => {
            return parseFloat(text).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
        {
          title: 'โยกเงิน/ถอนเงิน สูงสุด',
          key: 'tranferMax',
          dataIndex: 'tranferMax',
          customRender: (text, row, index) => {
            return parseFloat(text).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
        {
          title: 'เงินในบัญชีสูงสุด',
          key: 'amountMax',
          dataIndex: 'amountMax',
          customRender: (text, row, index) => {
            return parseFloat(text).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          },
        },
        {
          title: 'สถานะ',
          key: 'status',
          filters: [
            { text: 'รอการเปิดใช้งาน', value: 1 },
            { text: 'เปิดใช้งานดึงอัตโนมัติ', value: 2 },
            { text: 'ครบจำนวนดึงรายวัน', value: 3 },
            { text: 'ปิดใช้งานการดึง', value: 4 },
            { text: 'โอนไปบัญชีพัก', value: 5 },
            { text: 'อายัด', value: 6 },
            { text: 'รอ OTP', value: 7 },
          ],
          dataIndex: 'bankServiceStatus',
          scopedSlots: { customRender: 'status' },
          onFilter: (value, record) => record.bankServiceStatus.toString().includes(value.toString()),
        },
        {
          title: 'ตัวเลือก',
          key: 'Action',
          dataIndex: 'bankServiceId',
          scopedSlots: { customRender: 'Action' },
        },
      ],
      visible: false,
      accountName: '',
      form: {
        title: '',
        bankSetId: '',
        bankServiceId: '',
        accountNumber: '',
        accountUsername: '',
        accountPassword: '',
        bankPIN: '',
        tranferMax: 0,
        amountMax: 0,
      },
    }
  },
  methods: {
    clearForm() {
      this.form = {
        type: 'insert',
        title: '',
        bankSetId: '',
        bankServiceId: '',
        accountNumber: '',
        accountUsername: '',
        accountPassword: '',
        bankPIN: '',
        tranferMax: 0,
        amountMax: 0,
      }
    },
    showModal(type, id = null) {
      // get OpertorCode
      this.clearForm()
      this.form.type = type
      this.form.title = (type === 'insert') ? 'เพิ่มบัญชีธนาคาร' : 'แก้ไขบัญชีธนาคาร'

      apiClient.get('/bankService/getBankSet/bankATM').then(res => {
        if (res.data.code === '000') {
          this.bankSet = []
          this.bankSet = res.data.responseData.data
          if (type === 'update') {
            this.getDataBankService(id)
          } else {
            if (this.$route.params.bankSetId !== 'all') this.form.bankSetId = parseInt(this.$route.params.bankSetId)
            this.visible = !this.visible
          }
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    getDataBankService(bankServiceId) {
      apiClient.get(`/bankService/${bankServiceId}`).then(res => {
        if (res.data.code === '000') {
          const dataBankService = res.data.responseData.data[0]
          this.form.bankServiceId = bankServiceId
          this.form.bankId = dataBankService.bankId
          this.form.bankPIN = dataBankService.bankPIN
          this.form.bankSetId = dataBankService.bankSetId
          this.form.accountNumber = dataBankService.accountNumber
          this.form.accountUsername = dataBankService.accountUsername
          this.form.accountPassword = dataBankService.accountPassword
          this.form.tranferMax = dataBankService.tranferMax
          this.form.amountMax = dataBankService.amountMax

          this.visible = !this.visible
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error}`,
        )
      })
    },
    async getBankService() {
      // เช็คถ้าไม่มี Id ส่งเข้ามา ให้ดึงทั้งหมด
      // console.log("tt",this.$route.params)
      if (this.$route.params.bankSetId !== 'all') {
        this.getName()
      }
      await apiClient.get(`/bankService/getData/bankATM/${this.$route.params.bankSetId}`).then(response => {
        const res = response.data
        if (res.code === '000') {
          this.data = res.responseData.data
          if (this.data.length > 0) {
            const listOperater = this.data.map(function(item, pos) {
              return { text: item.operatorName, value: item.operatorName }
            })
            this.columns[1].filters = [
              ...new Map(listOperater.map((item) => [item.text, item])).values(),
            ]
          }
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
    async getName() {
      await apiClient.get(`/bankService/getName/${this.$route.params.bankSetId}`).then(response => {
        const res = response.data
        if (res.code === '000') {
          this.accountName = res.responseData.data[0].name
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
    onSubmit() {
      const title = (this.form.type === 'update') ? 'แน่ใจหรือไม่ที่ต้องการแก้ไข' : 'แน่ใจหรือไม่ที่ต้องการเพิ่มข้อมูล'
      Swal.fire({
        icon: 'info',
        title: title,
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showLoaderOnConfirm: true,
        preConfirm: (value) => {
          if (value) {
            // ส่งข้อมูลอัปเดทสถานะ
            if (this.form.bankServiceId !== '') {
              return apiClient.put(`bankService/bankATM/update/${this.form.bankServiceId}`, this.form).then(response => {
                if (response.status !== 200) {
                  throw new Error(response.message)
                }
                return response.data
              }).catch(error => {
                Swal.showValidationMessage(
                  `เกิดข้อผิดพลาด: ${error}`,
                )
              })
            } else {
              return apiClient.post('bankService/bankATM/create', this.form).then(response => {
                if (response.status !== 200) {
                  throw new Error(response.message)
                }
                return response.data
              }).catch(error => {
                Swal.showValidationMessage(
                  `เกิดข้อผิดพลาด: ${error}`,
                )
              })
            }
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          // console.log(result.value)
          const iconError = (result.value.code === '000') ? 'success' : 'error'
          Toast.fire({ icon: iconError, title: result.value.message })
          this.visible = false
          this.confirmLoading = false
          this.getBankService()

          if (result.value.responseData.checkOTP === true) {
            this.submitOTP(result.value.responseData.bankServiceId)
          }
        }
      })
    },
    async submitOTP(bankServiceId) {
      // sent otp

      const sentOTP = await apiClient.post('/bankService/registerscb', { bankserviceid: bankServiceId }).then(response => {
        if (response.status !== 200) {
          throw new Error(response.message)
        }
        return response.data
      }).catch(error => {
        Swal.showValidationMessage(
          `Request failed: ${error}`,
        )
      })
      // console.log(sentOTP);
      if (sentOTP.code === '000') {
        Swal.fire({
          title: 'กรุณากรอกข้อมูล OTP ที่ได้รับ',
          html:
            '<input id="otp" class="swal2-input" placeholder="กรุณากรอกข้อมูล"></input>',
          focusConfirm: false,
          showCancelButton: true,
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก',
          preConfirm: (value) => {
            if (value) {
              const otp = document.getElementById('otp').value
              if (otp === '') {
                Swal.showValidationMessage(
                  'กรุณากรอกข้อมูล',
                )
              } else {
                const data = {
                  otp: otp,
                  bankserviceid: bankServiceId,
                }

                return apiClient.post('/bankService/scbotp', data).then(response => {
                  if (response.status !== 200) {
                    throw new Error(response.message)
                  }
                  return response.data
                }).catch(error => {
                  Swal.showValidationMessage(
                    `Request failed: ${error}`,
                  )
                })
              }
            }
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
          if (result.isConfirmed) {
            const iconError = (result.value.code === '000') ? 'success' : 'error'
            Toast.fire({ icon: iconError, title: result.value.message })
            this.getBankService()
          }
        })
      } else {
        Swal.showValidationMessage(
          `Request failed: ${sentOTP.message}`,
        )
      }
    },
    handleOk(e) {
      this.onSubmit()
    },
    handleCancel(e) {
      this.visible = false
    },
    getStatus(type, status) {
      return getName(type, status)[0]
    },
    useAction(bankServiceId, status) {
      if (status === 1 || status === 4 || status === 3) this.updateBankStatus(bankServiceId, 'openAuto')
      if (status === 2) this.updateBankStatus(bankServiceId, 'closeBank')
      if (status === 7) this.submitOTP(bankServiceId)
    },
    async updateBankStatus(bankServiceId, type) {
      const bankServiceStatus = (type === 'openAuto') ? 2 : (type === 'closeBank') ? 4 : null
      const title = (type === 'openAuto') ? 'คุณแน่ใจหรือไม่ที่ต้องการเปิดใช้งานอัตโนมัติ' : (type === 'closeBank') ? 'คุณแน่ใจหรือไม่ที่ต้องการปิดการใช้งานอัตโนมัติ' : null

      if (bankServiceStatus) {
        await Swal.fire({
          title: title,
          icon: 'question',
          confirmButtonText: 'ยืนยัน',
          cancelButtonText: 'ยกเลิก',
          showCancelButton: true,
          showCloseButton: true,
          showLoaderOnConfirm: true,
          preConfirm: (value) => {
            if (value) {
              const data = { bankServiceId: bankServiceId, bankServiceStatus }
              return apiClient.post('/bankService/bankATM/updateStatus', data).then(response => {
                if (response.status !== 200) {
                  throw new Error(response.message)
                }
                return response.data
              }).catch(error => {
                Swal.showValidationMessage(
                  `Request failed: ${error}`,
                )
              })
            }
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
          if (result.isConfirmed) {
            const iconError = (result.value.code === '000') ? 'success' : 'error'
            Toast.fire({ icon: iconError, title: result.value.message })
            this.getBankService()
          }
        })
      }
    },
    closeBankSerivce(bankPaymentId) {

    },
    refreshData() {
      this.loading(true)
      this.getBankService()
      this.loading(false)
    },
    async loading(e) {
      if (e) {
        Swal.fire({
          title: 'กำลังตรวจสอบ',
          text: 'ระบบกำลังตรวจสอบข้อมูล กรุณารอสักครู่.',
          showConfirmButton: false,
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
      } else {
        Swal.close()
      }
    },
  },
  async created() {
    await this.getBankService()
  },

}
</script>

<style>

</style>
